import React, { useEffect } from "react";
import "./Risk_Disclosure_Agreement.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import parse from "html-react-parser"
import { useDispatch, useSelector } from "react-redux";
import { GetRiskDisclosureAgreement } from "../../redux/aboutus";

function Risk_Disclosure_Agreement() {

  const dispatch = useDispatch()
  const about_us = useSelector((state) => state.aboutus);
  useEffect(() => {
    dispatch(GetRiskDisclosureAgreement());
  }, [dispatch]);
  return (
    <>
      <section className="Confidentiality_Agreement Risk_Disclosure_Agreement">
        <Common_white_header headingText={"Risk Disclosure Agreement"} />
        <div className="container">
          <div className="text_holder">
            {parse(about_us?.data?.description || "")}
          </div>
        </div>
      </section>
    </>
  );
}

export default Risk_Disclosure_Agreement;
